"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Stream = void 0;

var _events = require("events/"),
    _webviewProtocol = require("@daangn/webview-protocol"),
    _createMessage = require("./createMessage"),
    _getEnvironment = require("./getEnvironment"),
    _observable = require("./observable");

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var Stream = /*#__PURE__*/function () {
  function Stream(a) {
    _classCallCheck(this, Stream);

    this.driver = a, _defineProperty(this, "_eventEmitter", void 0), _defineProperty(this, "_dispose", void 0), this._eventEmitter = new _events.EventEmitter();
  }

  _createClass(Stream, [{
    key: "on",
    value: function on(a, b) {
      var _this = this;

      "Web" === (0, _getEnvironment.getEnvironment)() || this._dispose || (this._dispose = (0, _observable.observable)(this.driver).postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqStreamSubscribe
      })).on(function (a) {
        return _this.onMessage(a);
      }));

      var c = this._eventEmitter.on(a, b);

      return function () {
        c.off(a, b);
      };
    }
  }, {
    key: "emit",
    value: function emit(a, b) {
      var c = {
        eventName: a
      };

      switch (b && (c.data = JSON.stringify(b)), (0, _getEnvironment.getEnvironment)()) {
        case "Web":
          return this.onMessage((0, _createMessage.createMessage)({
            type: _webviewProtocol.Type.ResStreamEvent,
            payload: {
              stream: c
            }
          }));

        default:
          this.driver.postMessage((0, _createMessage.createMessage)({
            type: _webviewProtocol.Type.ReqStreamEmit,
            payload: {
              stream: c
            }
          }));
      }
    }
  }, {
    key: "onMessage",
    value: function onMessage(a) {
      var b, c;
      if ("error" in a) throw new Error(a.error);
      if (!(null !== (b = a.payload) && void 0 !== b && null !== (c = b.stream) && void 0 !== c && c.eventName)) return console.error("Error 25859: PayloadStream.eventName\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4");
      var d = a.payload.stream.eventName;
      a.payload.stream.data ? this._eventEmitter.emit(d, JSON.parse(a.payload.stream.data)) : this._eventEmitter.emit(d, void 0);
    }
  }]);

  return Stream;
}();

exports.Stream = Stream;